module.exports = __webpack_public_path__ + "static/img/header-logo.9790510.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/header-logo.gif
// module id = 8N6R
// module chunks = 1